export default __webpack_public_path__ + "static/media/questionHealthgenom.4b358159.svg";